<template>
    <div class="modalDialog is-active" role="dialog" aria-labelledby="modal-title" aria-describedby="modal-description" aria-hidden="true" @keyup.esc="modalClose">
        <div class="modal-contents">
            <div>
                <a title="Close" class="close" @click="modalClose">X</a>
                <h3><slot id="modal-title" name="header">Confirm</slot></h3>
                <hr />
            </div>
            <div>
                <slot id="modal-description" name="body">
                    Are you Sure?
                </slot>
                <hr />
            </div>
            <div class="right">
                <span v-if="button3">
                    <button class="btn btn-warning m-right-10" @click="modalButton3"><span v-if="modalData && modalData.button3Label">{{modalData.button3Label}}</span><span v-else>Maybe</span></button>
                </span>
                <span v-if="buttonNo">
                    <button class="btn btn-default m-right-10" @click="modalCancel"><span v-if="modalData && modalData.buttonNoLabel">{{modalData.buttonNoLabel}}</span><span v-else>No</span></button>
                </span>
                <span v-if="buttonYes">
                    <button class="btn btn-primary" @click="modalConfirm"><span v-if="modalData && modalData.buttonYesLabel">{{modalData.buttonYesLabel}}</span><span v-else>Yes</span></button>
                </span>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>
<script>
import {defineComponent} from 'vue';
export default defineComponent ({
    emits: ['modal-close', 'modal-cancel', 'modal-confirm', 'modal-button3'],
    props: {
        data: {
            type: Object,
            default: {}
        },
        modalid: {
            required: true,
        },

        button3: {
            default: false
        },

        buttonNo: {
            default: true
        },

        buttonYes: {
            default: true
        }

    },

    data() {
        return {
            modalData: '',
        }
    },

    methods: {
        modalClose(event) {
            this.$emit('modal-close');
        },
        modalCancel() {
            this.$emit('modal-cancel');
            this.modalClose();
        },
        modalConfirm() {
            this.$emit('modal-confirm');
            this.modalClose();
        },
        modalButton3() {
            this.$emit('modal-button3');
            this.modalClose();
        }
    },
    created() {
        this.modalData = this.data;
    },
    mounted () {
        this.$el.focus();
        let focusableEls = Array.prototype.slice.call(this.$el.querySelectorAll('input:not([hidden]), select:not([hidden]), textarea:not([hidden]), button:not([hidden]), a[href], area[href], [tabindex="0"]'))
        focusableEls[0].focus();
    }
});

</script>